import { CustomUseQueryOptions } from '../types';
import { getOptions } from '@/libs/sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import type { Address, PublicClient } from 'viem';

export const useOptions = (client: PublicClient, address?: Address, options?: CustomUseQueryOptions<readonly Address[]>) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && !!address,
    // PredictionCTF contracts don't have options() — disable retry to avoid wasted RPC calls
    retry: false,
    queryKey: [queryKey, 'UseOptions', client, address],
    queryFn: async () => await getOptions(address!, client),
  });
};
